import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class ComponentDeactivateGuardService  {

  formEdit;

  constructor() {
  }


  formEditInitiated() {
    if (!this.isUserInMiddleOfEditing()) {
      this.formEdit = true;
    }
  }

  formEditEnded() {
    this.formEdit = false;
  }

  isUserInMiddleOfEditing() {
    return this.formEdit;
  }

  canDeactivate(component: any): boolean {
    let canDeactivateRoute = true;
    if (this.formEdit) {
      if (!window.confirm("Are you sure you want to discard editing?").valueOf()) {
        canDeactivateRoute = false;
      } else {
        this.formEditEnded();
      }
    }
    return canDeactivateRoute;
  }
}
